// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/Currency.yaml
// Generated: 2026-03-27T07:15:40.009Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateCurrency, UpdateCurrency, Currency } from '@/types/core/Currency';

/**
 * Currency Service
 * CRUD operations for Currency via the ABP API.
 */
export const currencyService = new EntityService<Currency, CreateCurrency, UpdateCurrency>(
  '/api/core/currency',
  'Currency',
);
